import React, { useCallback } from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface LoanTenureInputProps {
  value?: Record<string, any>;
  onChange?: (data: Record<string, any>) => void;
  disabled?: boolean;
}

const LoanTenureInput: React.FC<LoanTenureInputProps> = ({
  value = {},
  onChange,
  disabled = false,
}) => {
  const currentValue = value?.loan_tenure ?? '';

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    onChange?.({ loan_tenure: val === '' ? '' : Number(val) });
  }, [onChange]);

  return (
    <div className="space-y-1.5">
      <Label htmlFor="loan_tenure" className="text-sm font-medium text-gray-700">
        Requested Loan Tenure (Months)
      </Label>
      <Input
        id="loan_tenure"
        type="number"
        value={currentValue}
        onChange={handleChange}
        disabled={disabled}
        placeholder="e.g. 12"
        className="mt-1"
      />
    </div>
  );
};

export default LoanTenureInput;
